import loaderImg from "assets/spinner.png";

export function Loader({ className }: { className?: string }) {
  return <img src={loaderImg} alt="loader" width="100%" height="100%" className={className} />;
}
